if (!customElements.get('compression-tabs')) {
  customElements.define(
    'compression-tabs',
    class CompressionTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('.compression-tabs__tab'));
        this.panels = Array.from(this.querySelectorAll('.compression-tabs__panel'));

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activate(tab.dataset.level));
          tab.addEventListener('keydown', (event) => this.handleKeydown(event));
        });
      }

      activate(level) {
        this.tabs.forEach((tab) => {
          const isActive = tab.dataset.level === level;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        this.panels.forEach((panel) => {
          const isActive = panel.dataset.level === level;
          panel.classList.toggle('is-active', isActive);
          if (isActive) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      }

      handleKeydown(event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();

        const currentIndex = this.tabs.indexOf(document.activeElement);
        if (currentIndex === -1) return;

        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const nextIndex = (currentIndex + direction + this.tabs.length) % this.tabs.length;
        const nextTab = this.tabs[nextIndex];

        nextTab.focus();
        this.activate(nextTab.dataset.level);
      }
    }
  );
}
